import { Modal, Button, Space, Spin } from 'antd'
import { 
  LeftOutlined, 
  RightOutlined, 
  ZoomInOutlined, 
  ZoomOutOutlined,
  DownloadOutlined,
  FullscreenOutlined,
  CloseOutlined
} from '@ant-design/icons'
import { useState } from 'react'

interface DocPreviewModalProps {
  visible: boolean
  docType?: 'question' | 'reply'
  docUrl?: string
  onClose: () => void
}

const DocPreviewModal = ({ visible, docType, docUrl, onClose }: DocPreviewModalProps) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(3)
  const [zoom, setZoom] = useState(100)
  const [loading, setLoading] = useState(false)

  const docTitle = docType === 'question' ? '质疑函' : '答复函'

  const handleZoomIn = () => {
    setZoom(prev => Math.min(prev + 20, 200))
  }

  const handleZoomOut = () => {
    setZoom(prev => Math.max(prev - 20, 50))
  }

  const handlePrevPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1))
  }

  const handleNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages))
  }

  return (
    <Modal
      title={`📄 文档预览 - ${docTitle}`}
      open={visible}
      onCancel={onClose}
      width="90%"
      style={{ maxWidth: 1200 }}
      footer={null}
      className="doc-preview-modal"
    >
      <div className="doc-preview-container">
        {/* 工具栏 */}
        <div className="doc-preview-toolbar">
          <Space>
            <Button 
              icon={<LeftOutlined />} 
             
              disabled={currentPage <= 1}
              onClick={handlePrevPage}
            />
            <span className="text-sm">
              第 {currentPage} 页 / 共 {totalPages} 页
            </span>
            <Button 
              icon={<RightOutlined />} 
             
              disabled={currentPage >= totalPages}
              onClick={handleNextPage}
            />
          </Space>

          <Space>
            <Button icon={<ZoomOutOutlined />} onClick={handleZoomOut} />
            <span className="text-sm w-16 text-center">{zoom}%</span>
            <Button icon={<ZoomInOutlined />} onClick={handleZoomIn} />
            <Button icon={<DownloadOutlined />}>下载</Button>
            <Button icon={<FullscreenOutlined />}>全屏</Button>
            <Button icon={<CloseOutlined />} danger onClick={onClose}>关闭</Button>
          </Space>
        </div>

        {/* 文档内容区域 */}
        <div className="doc-preview-content">
          <Spin spinning={loading}>
            <div 
              className="bg-white mx-auto shadow-lg"
              style={{ 
                width: `${zoom}%`, 
                minHeight: 800,
                padding: 60,
                transformOrigin: 'top center'
              }}
            >
              {/* 模拟文档内容 */}
              <div className="text-center mb-12">
                <h1 className="text-2xl font-bold mb-8">{docTitle}</h1>
              </div>
              
              <div className="space-y-6 text-base leading-relaxed">
                <p>致：招标人/采购人</p>
                
                <p className="indent-8">
                  我公司对贵单位组织的"项目名称"的{docType === 'question' ? '中标结果提出质疑' : '质疑进行答复'}。
                </p>
                
                <p className="indent-8">
                  {docType === 'question' 
                    ? '根据《招标投标法实施条例》等相关法律法规，我公司认为本次招标过程中存在以下问题：'
                    : '经调查核实，现就贵公司提出的质疑事项答复如下：'
                  }
                </p>

                <div className="mt-8">
                  <h3 className="font-bold mb-4">
                    {docType === 'question' ? '一、质疑事项' : '一、答复意见'}
                  </h3>
                  <p className="indent-8">
                    {docType === 'question'
                      ? '1. 关于资格条件设置的问题。招标文件中要求投标人具备...'
                      : '1. 关于资格条件设置的质疑。经核查，招标文件中的资质要求符合...'
                    }
                  </p>
                </div>

                <div className="mt-8">
                  <h3 className="font-bold mb-4">
                    {docType === 'question' ? '二、事实依据' : '二、法律依据'}
                  </h3>
                  <p className="indent-8">
                    根据《中华人民共和国招标投标法》及其实施条例的相关规定...
                  </p>
                </div>

                <div className="mt-12 text-right">
                  <p>质疑/答复单位：XXX公司</p>
                  <p>日期：2024年XX月XX日</p>
                </div>
              </div>
            </div>
          </Spin>
        </div>

        {/* 底部提示 */}
        <div className="bg-gray-100 p-3 text-center text-sm text-gray-500">
          💡 提示: 选中文字后，点击"填充到表单"可快速填充到当前编辑字段
        </div>
      </div>
    </Modal>
  )
}

export default DocPreviewModal
